export const removeSpecialCharacters = (input) => {
  if (!input) return "";

  return input.replace(/[^a-zA-Z0-9\s]/g, "");
}